import logo from "../Assets/Logo.png";
import React, { useState, useEffect, useRef, useContext } from "react";
import { Link, NavLink, useLocation, useNavigate } from "react-router-dom";
import { Modal, ModalBody, ModalHeader } from "reactstrap";
import { Create_Api, Get_Api } from "../Api_Url";
import { toast } from "react-toastify";
import { CountryContext } from "./CountryProvider";

function Navbar() {
  const navigate = useNavigate();
  const location = useLocation();
  const [AllDestination, setAllDestination] = useState([]);
  const [IsUploading, setIsUploading] = useState(false);
  const { setSelectedCountry, setCountryName } = useContext(CountryContext);

  const GetAllDestination = async () => {
    try {
      setIsUploading(true);
      const response = await Get_Api(`api/admin/GetAllDestination`);
      setAllDestination(response?.data);
      setIsUploading(false);
    } catch (error) {
      setIsUploading(false);
      console.log(error);
    }
  };

  useEffect(() => {
    GetAllDestination();
  }, []);

  const [selectedDestination, setSelectedDestination] = useState("");

  const handleChange = (e) => {
    setSelectedDestination(e.target.value);
  };

  const [Name, setName] = useState("");
  const [Email, setEmail] = useState("");
  const [Number, setNumber] = useState("");

  const SendContactUs = async (e) => {
    e.preventDefault();
    if (!Name) return toast.error("Name is required!");
    if (!Email) return toast.error("Email is required!");
    if (!Number) return toast.error("Number is required!");
    try {
      let data = {
        Name,
        Email,
        Number,
        Destination: selectedDestination
      };
      setIsUploading(true);
      const response = await Create_Api(
        `api/admin/CreateDestinationForm`,
        data
      );
      toast.success(response?.message);
      setName("");
      setEmail("");
      setNumber("");
      setSelectedDestination("");
      setIsUploading(false);
      setmodal(false);
    } catch (error) {
      setIsUploading(false);
      toast.error(error?.response?.data?.message);
      console.log(error);
    }
  };

  const [modal, setmodal] = useState(false);

  const [isDivVisible, setIsDivVisible] = useState(false);
  const [user, setUser] = useState(null);
  const [isHovered, setIsHovered] = useState(false);
  const toggleDivRef = useRef(null);

  const openToggleDiv = () => {
    setIsDivVisible(true);
  };

  const closeToggleDiv = () => {
    setIsDivVisible(false);
  };

  const handleClickOutside = (event) => {
    if (toggleDivRef.current && !toggleDivRef.current.contains(event.target)) {
      closeToggleDiv();
    }
  };

  useEffect(() => {
    if (isDivVisible) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isDivVisible]);

  const [AllCountry, setAllCountry] = useState([]);
  const [openCountry, setOpenCountry] = useState(null);

  const Get_All_Country = async () => {
    try {
      const response = await Get_Api("api/admin/GetAllCountry");
      setAllCountry(response.data);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    Get_All_Country();
  }, []);

  const OntoPage = (page, CountryId, CountryName) => {
    console.log(page, CountryId, CountryName);
    if (CountryId) {
      setSelectedCountry(CountryId);
      setCountryName(CountryName);
    }
    if (CountryId == null) {
      setSelectedCountry(null);
    }
    const link = `/${page}/${CountryId}`;
    console.log(link);
    window.location.href = link;
    // window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const navigateto = (page) => {
    window.scrollTo({ top: 0, behavior: "smooth" });
    navigate(`/${page}`)
  }
  return (
    <>
      <nav>
        <img onClick={() => { navigateto('') }} src={logo} />
        {/* <ul>
          <Link className="none" to="/">
            <li>Home</li>
          </Link>
          <Link className="none" to="/about">
            <li>About</li>
          </Link>
          <Link
            className="none"
            to="/country"
          >
            <li>
              Country
            </li>
          </Link>

          <Link className="none" to="/contact">
            <li>Contact Us</li>
          </Link>
          <Link className="none" to="/whyus">
            <li>Why Us</li>
          </Link>

          <Link className="none" to="/blog">
            <li>Blog</li>
          </Link>
          <button onClick={() => setmodal(true)} className="booknow">
            Enquire Now
          </button>
        </ul> */}
        <ul>
          <Link className="none" to="/">
            <li
              style={{
                borderBottom: location.pathname === "/" ? "2px solid #4DA628" : "none",
              }}
            >
              Home
            </li>
          </Link>

          <Link className="none" to="/about">
            <li
              style={{
                borderBottom: location.pathname === "/about" ? "2px solid #4DA628" : "none",
              }}
            >
              About
            </li>
          </Link>

          <Link className="none" to="/country">
            <li
              style={{
                borderBottom: location.pathname === "/country" ? "2px solid #4DA628" : "none",
              }}
            >
              Country
            </li>
          </Link>

          <Link className="none" to="/contact">
            <li
              style={{
                borderBottom: location.pathname === "/contact" ? "2px solid #4DA628" : "none",
              }}
            >
              Contact Us
            </li>
          </Link>

          <Link className="none" to="/whyus">
            <li
              style={{
                borderBottom: location.pathname === "/whyus" ? "2px solid #4DA628" : "none",
              }}
            >
              Why Us
            </li>
          </Link>

          <Link className="none" to="/blog">
            <li
              style={{
                borderBottom: location.pathname === "/blog" ? "2px solid #4DA628" : "none",
              }}
            >
              Blog
            </li>
          </Link>

          <button onClick={() => setmodal(true)} className="booknow">
            Enquire Now
          </button>
        </ul>

        <i
          style={{ color: "white", cursor: "pointer" }}
          className="bi bi-list"
          onClick={isDivVisible ? closeToggleDiv : openToggleDiv}
        ></i>
      </nav>
      {isDivVisible && (
        <div className="toggleDiv-ops">
          <div className="toggleDiv" ref={toggleDivRef}>
            <ul>
              <NavLink exact className="none" activeClassName="active" to="/">
                <li>Home</li>
              </NavLink>

              <NavLink className="none" activeClassName="active" to="/about">
                <li>About</li>
              </NavLink>

              <NavLink className="none" activeClassName="active" to="/contact">
                <li>Contact Us</li>
              </NavLink>
              <NavLink
                className="none"
                activeClassName="active"
                to="/destination"
              >
                <li>Destination</li>
              </NavLink>
            </ul>
          </div>
        </div>
      )}

      <Modal size="md" isOpen={modal} toggle={() => setmodal(!modal)}>
        <ModalHeader toggle={() => setmodal(!modal)}>Enquire Now</ModalHeader>
        <ModalBody>
          <div className="bookform">
            <label>Name</label>
            <input
              placeholder="Enter Your Name"
              value={Name}
              onChange={(e) => {
                setName(e.target.value);
              }}
            />
            <label>Email</label>
            <input
              placeholder="Enter Your Email"
              value={Email}
              onChange={(e) => {
                setEmail(e.target.value);
              }}
            />
            <label>Contact </label>
            <input
              placeholder="Enter Your Mobile no."
              value={Number}
              onChange={(e) => {
                setNumber(e.target.value);
              }}
            />
            <>
              <label>Destination</label>
              <select value={selectedDestination} onChange={handleChange}>
                <option value="" disabled>
                  Select one...
                </option>
                {AllDestination.map((dest) => (
                  <option key={dest?._id} value={dest?._id}>
                    {dest?.DestinationName}
                  </option>
                ))}
              </select>
            </>
            <br />
            <button
              onClick={(e) => {
                SendContactUs(e);
              }}
            >
              {IsUploading ? "Please Wait" : "Submit"}
            </button>
          </div>
        </ModalBody>
      </Modal>
    </>
  );
}

export default Navbar;
